import React, { useEffect, useState } from "react";
import {
  f7,
  Page,
  Link,
  Navbar,
  NavTitle,
  NavRight,
  Button,
  Badge,
  Toolbar,
  Tabs,
  Tab,
  Block,
  BlockTitle,
  Popup,
  Card,
  CardHeader,
  CardContent,
  CardFooter,
  List,
  ListItem,
  ListItemCell,
  ListInput,
  Icon,
  Range,
  Row,
  Col,
  Input,
  AccordionItem,
  AccordionToggle,
  AccordionContent,
} from "framework7-react";

import DeliveryPriceCity from "./deliveryPriceCity";

function DeliveryPriceState({
  state,
  cities,
  country,
  editDeliveryPrice,
  deleteDeliveryPrice,
}) {
  const [citySearch, setCitySearch] = useState("");
  const randomID = Math.floor(Math.random() * 100000);
  return (
    <Card style={{ width: "100%", margin: "10pt auto" }} >
    <AccordionItem
      onAccordionOpened={(_) => {
        document.getElementById(`${randomID}`).style.transform =
          "rotate(180deg)";
      }}
      onAccordionClosed={(_) => {
        document.getElementById(`${randomID}`).style.transform =
          "rotate(0deg)";
      }}
    >
      <AccordionToggle>
        <CardHeader className="no-border">
          <span>{state}</span>
          <span>
            <Button
              outline
              iconF7="arrowtriangle_down_fill"
              id={`${randomID}`}
            ></Button>
          </span>
        </CardHeader>
      </AccordionToggle>
      <AccordionContent>
        <CardContent className="bg-color-white no-padding">
          <Card className=" m-0">
            <CardHeader className="p-16 justify-start items-center">
              <Icon f7="search" style={{ width: 18, height: 18 }} />
              <Input
                type="text"
                placeholder="Search for city..."
                className="px-8 flex-grow"
                value={citySearch}
                onChange={(e) => setCitySearch(e.target.value)}
              />
            </CardHeader>
            <CardContent className="no-padding bg-color-gray-100 card-content-cities">
              {Object.keys(cities).length &&
                Object.keys(cities)
                  .filter((city) =>
                    city.toLowerCase().includes(citySearch.toLowerCase()),
                  )
                  .sort()
                  .map((city) => (
                    <DeliveryPriceCity
                      country={country}
                      state={state}
                      city={city}
                      cityData={cities[city]}
                      key={city}
                      editDeliveryPrice={editDeliveryPrice}
                      deleteDeliveryPrice={deleteDeliveryPrice}
                    />
                  ))}
            </CardContent>
          </Card>
        </CardContent>
      </AccordionContent>
    </AccordionItem>
    </Card>
  );
}

export default DeliveryPriceState;
